import { render, staticRenderFns } from "./fullFieldParameters.vue?vue&type=template&id=24601e84&scoped=true&"
import script from "./fullFieldParameters.vue?vue&type=script&lang=js&"
export * from "./fullFieldParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24601e84",
  null
  
)

export default component.exports